import script from "./TimelapseControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelapseControls.vue?vue&type=script&setup=true&lang=ts"

import "./TimelapseControls.vue?vue&type=style&index=0&id=44819450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44819450"]])

export default __exports__